import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import muiThemeable from 'material-ui/styles/muiThemeable'

const MainHeader = muiThemeable()(
  glamorous.h1(({
    muiTheme: {
      palette: {
        textColor,
      },
    },
  }) => ({
    margin: '10px 0 20px',
    color: textColor,
  }),(
    ({
      noMarginBottom,
      filled,
      small,
      muiTheme: {
        palette: {
          accent2Color,
        },
      },
      fontWeight = 300,
    }) => ({
      marginBottom: noMarginBottom ? 0 : '',
      backgroundColor: filled ? accent2Color : 'transparent',
      padding: filled ? 10 : 0,
      fontSize: small ? 18 : 22,
      fontWeight: !fontWeight ? 300 : fontWeight,
    })
  ))
)

MainHeader.propTypes = {
  noMarginBottom: PropTypes.bool,
  filled: PropTypes.bool,
  small: PropTypes.bool,
}
MainHeader.defaultProps = {
  noMarginBottom: false,
  filled: false,
  small: false,
}

export default MainHeader



// WEBPACK FOOTER //
// ./src/components/headers/MainHeader.js